"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_mute__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mute_hi_dark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 96,
    y1: 121.11,
    x2: 96,
    y2: 171.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,16.5h0a28,28,0,0,1,28,28v37a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28v-37A28,28,0,0,1,96,16.5Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,107.49a28,28,0,0,1-28-28v2a28,28,0,1,0,56,0v-2A28,28,0,0,1,96,107.49Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92,48a4,4,0,0,0-4-4H68v8H88A4,4,0,0,0,92,48Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4a4d4e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.86,49A4.09,4.09,0,0,0,92,48a4,4,0,0,0-4-4H68v2H88A4,4,0,0,1,91.86,49Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92,60a4,4,0,0,0-4-4H68v8H88A4,4,0,0,0,92,60Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4a4d4e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.86,61A4.09,4.09,0,0,0,92,60a4,4,0,0,0-4-4H68v2H88A4,4,0,0,1,91.86,61Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92,72a4,4,0,0,0-4-4H68v8H88A4,4,0,0,0,92,72Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4a4d4e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.86,73A4.09,4.09,0,0,0,92,72a4,4,0,0,0-4-4H68v2H88A4,4,0,0,1,91.86,73Z",
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100,48a4,4,0,0,1,4-4h20v8H104A4,4,0,0,1,100,48Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4a4d4e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.14,49a4.09,4.09,0,0,1-.14-1,4,4,0,0,1,4-4h20v2H104A4,4,0,0,0,100.14,49Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100,60a4,4,0,0,1,4-4h20v8H104A4,4,0,0,1,100,60Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4a4d4e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.14,61a4.09,4.09,0,0,1-.14-1,4,4,0,0,1,4-4h20v2H104A4,4,0,0,0,100.14,61Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100,72a4,4,0,0,1,4-4h20v8H104A4,4,0,0,1,100,72Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4a4d4e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.14,73a4.09,4.09,0,0,1-.14-1,4,4,0,0,1,4-4h20v2H104A4,4,0,0,0,100.14,73Z",
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M100,159.62V125.8a44.24,44.24,0,0,0,40-43.75,4,4,0,0,0-4-4h0a4,4,0,0,0-4,4,36,36,0,1,1-72,0,4,4,0,1,0-8,0A44.24,44.24,0,0,0,92,125.8v33.84a67.19,67.19,0,0,0-35.18,12.55A2.11,2.11,0,0,0,58.07,176h76.24a2.11,2.11,0,0,0,1.25-3.81A67.14,67.14,0,0,0,100,159.62Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.06
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.31,174H58.07a2.08,2.08,0,0,1-1.87-1.12A2.13,2.13,0,0,0,58.07,176h76.24a2.12,2.12,0,0,0,1.86-3.12A2.06,2.06,0,0,1,134.31,174Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 125.82,
    width: 8,
    height: 33.68,
    style: {
      opacity: 0.200000002980232,
      isolation: "isolate",
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100,125.8A44.25,44.25,0,0,0,140,82a4,4,0,0,0-4-4h0a4,4,0,0,0-4,4,36,36,0,1,1-72,0,4,4,0,1,0-8,0A44.24,44.24,0,0,0,92,125.8,39.76,39.76,0,0,0,100,125.8Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,123.81a39.18,39.18,0,0,1-8,0A44.23,44.23,0,0,1,52,81.58,2,2,0,0,0,52,82,44.24,44.24,0,0,0,92,125.8a39.76,39.76,0,0,0,8,0A44.25,44.25,0,0,0,140,82a3,3,0,0,0-.05-.43A44.23,44.23,0,0,1,100,123.81Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "cf38d353-8d1e-4321-b7cd-addd6f8ca3c5",
    x1: 35.41,
    y1: 156.55,
    x2: 156.5,
    y2: 35.45,
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.05369407146173px"
    }
  }));
}

var _default = ic_mute__dark;
exports.default = _default;